import { render, staticRenderFns } from "./LanhuColorIcon.vue?vue&type=template&id=f3ac412a&"
import script from "./LanhuColorIcon.vue?vue&type=script&lang=js&"
export * from "./LanhuColorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports